export const COMPETITION_CATEGORY = {
  WORLD_ATHLETICS_SERIES: 0,
  WORLD_ATHLETICS_WORLD_RELAYS: 1,
  ONE_DAY_MEETING_CIRCUITS: 2,
  WORLD_ATHLETICS_ROAD_RACE_LABELS: 3,
  WORLD_ATHLETICS_CHALLENGES: 4,
  WORLD_ATHLETICS_PERMITS: 5,
  OTHER_INTERNATIONAL_CHAMPIONSHIPS: 6,
  SPECIAL_CASE: 7,
};

export const COMPETITION_CODE = {
  WORLD_ATHLETICS_SERIES: 'WAS',
};
